import React, { FC } from "react";
import { FullWidthLayout, SectionLayout } from "@/layouts";
import { useTranslation } from "react-i18next";
import * as Styled from "./mainContact.styles";

export const MainScreenContact: FC = () => {
  const { t } = useTranslation("global");
  return (
    <FullWidthLayout id="signUp" bgColor="var(--tertiary-99)">
      <SectionLayout className="animate__animated animate__fadeIn">
        <Styled.MainContainer>
          <Styled.TextBox>
            <h1 className="display-large"> {t("contactMain.title")} </h1>
            <p className="headline-medium"> {t("contactMain.description")} </p>
          </Styled.TextBox>
          <div>
            <Styled.ImgBox>
              <img
                className="animate__animated animate__fadeIn animate__delay-0.8s"
                src="/assets/contact/main/contactMain.webp"
                alt="contact"
              />
            </Styled.ImgBox>
          </div>
        </Styled.MainContainer>
      </SectionLayout>
    </FullWidthLayout>
  );
};
